import classnames from 'classnames'
import * as PropTypes from 'prop-types'
import React from 'react'
import Link from '../../components/Navigation/Link/Link'
import 'url-search-params-polyfill'

function ArticleTag (props) {
  return <span className='badge badge-transparent text-white badge-pill px-2 py-1 font-size-normal mr-1 mb-1'>
    {props.children}
  </span>
}

ArticleTag.propTypes = { tag: PropTypes.any }

export function ArticleTags (props) {
  const classNames = classnames({ 'mb-4': props.frontmatter.author_description })
  return (
    <div>
      {props.frontmatter.tags.map((tag) => {
        const urlSearchParams = new URLSearchParams()
        urlSearchParams.append('search', tag)
        return (
          <ArticleTag>
            <Link
              to={`/tutorials/?${urlSearchParams.toString()}`}
              classNames='text-white font-weight-bold'
            >
              {tag}
            </Link>
          </ArticleTag>)
      })}
    </div>)
}

export function ArticleSocial () {
  return (
    <div className='meta-numbers'>
      <span><i className='fa fa-star-o' /> 366</span>{'  '}
      <span><i className='fa fa-eye' /> 2.9k</span>
    </div>
  )
}

ArticleTags.propTypes = { frontmatter: PropTypes.any }
